import { render, staticRenderFns } from "./BenificiaryBus.vue?vue&type=template&id=21720bb6&scoped=true"
import script from "./BenificiaryBus.vue?vue&type=script&lang=js"
export * from "./BenificiaryBus.vue?vue&type=script&lang=js"
import style0 from "./BenificiaryBus.vue?vue&type=style&index=0&id=21720bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21720bb6",
  null
  
)

export default component.exports